import { Box } from '@mantine/core';
import { LoadingSkeleton } from 'components/LoadingSkeleton';
import { ReferencesList } from 'components/ReferencesList';
import { ReferencesListMobile } from 'components/ReferencesListMobile';
import { useGetWorkerReferencesQuery } from 'redux/Api/referencesApi/referencesApi';
import styles from './EmployedsProfileContent.module.scss';
import { Text } from '@mantine/core';
import { useEffect } from 'react';

export const ReferencesProfileContent = ({
  worker,
  onRefetchReady,
}: {
  worker: any;
  onRefetchReady?: (refetch: () => void) => void;
}) => {
  const {
    data,
    isLoading: isReferencesLoading,
    refetch,
  } = useGetWorkerReferencesQuery({
    id: worker?.id,
  });

  useEffect(() => {
    if (onRefetchReady) {
      onRefetchReady(refetch);
    }
  }, [refetch, onRefetchReady]);

  return isReferencesLoading ? (
    <LoadingSkeleton />
  ) : data?.length ? (
    <>
      <Box visibleFrom='sm'>
        <div className={styles.customContractTable}>
          <ReferencesList
            intersectionComponent={null}
            data={data || []}
            hidePerformer={true}
            workerId={worker?.id?.toString()}
          />
        </div>
      </Box>
      <Box hiddenFrom='sm'>
        <div className={styles.customContractMobile}>
          <ReferencesListMobile
            intersectionComponent={null}
            data={data || []}
            workerId={worker?.id?.toString()}
          />
        </div>
      </Box>
    </>
  ) : (
    <Text lh='22px' c='#71869D' fz='16px'>
      Нет загруженных справок
    </Text>
  );
};
